module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-nprogress@5.2.0_gatsby@4.24.4/node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"#2A9CD4","showSpinner":false},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-manifest@5.1.0_gatsby@4.24.4/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"경북소프트웨어고 포트폴리오","short_name":"경소고 포트폴리오","start_url":"/","background_color":"#f5f5f5","theme_color":"#2A9CD4","display":"standalone","icon":"src/favicon.svg","cache_busting_mode":"none","legacy":true,"theme_color_in_head":true,"crossOrigin":"anonymous","include_favicon":true,"cacheDigest":null},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@4.24.4_yalvw3r2waubxycyb7k7qsruca/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
